<template>
  <v-list-item
    :href="geoportal.website"
    target="_blank"
    rel="noopener"
  >
    <v-list-item-avatar tile>
      <v-img
        v-if="geoportal.image"
        :src="`${publicPath}img/loga/${geoportal.image}`"
        contain
      />
      <v-img
        v-else
        :src="`${publicPath}img/coa/svg/${geoportal.TERYT}.svg`"
        contain
      />
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title>
        {{ geoportal.name }}
      </v-list-item-title>
      <v-list-item-subtitle>
        {{ geoportal.TERYT }}
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-spacer />
      <v-row>
        <template v-slot:activator="{ on }">
          <v-btn
            text
            icon
            class="ml-auto"
            color="primary"
            v-on="on"
          >
            <v-icon>mdi-map</v-icon>
          </v-btn>
        </template>
        <template v-slot:activator="{ on }">
          <v-btn
            text
            icon
            class="ml-auto"
            color="primary"
            v-on="on"
          >
            <v-icon>mdi-home</v-icon>
          </v-btn>
        </template>
      </v-row>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
export default {
  name: 'ListItemCounty',
  props: {
    geoportal: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
